module.exports = __webpack_public_path__ + "img/urcode.43e2ca61.png";